import React, { useState } from 'react';
import {
  Tabs,
  Tab,
  Box,
} from '@mui/material';
import NodesTable from './Tabs/NodesTable';
import EdgesTable from './Tabs/EdgesTable';
import Meta from './Tabs/Meta';

export default function Handler() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (event, value) => {
    setCurrentTab(value);
  };

  return (
    <Box sx={{ background: '#fff' }}>
      <Tabs value={currentTab} onChange={handleChange} sx={{ mb: 1 }}>
        <Tab label="About" />
        <Tab label="Nodes" />
        <Tab label="Links" />
      </Tabs>
      <Box value={currentTab} index={0} hidden={currentTab !== 0}>
        <Meta />
      </Box>
      <Box value={currentTab} index={1} hidden={currentTab !== 1}>
        <NodesTable visible={currentTab === 1} />
      </Box>
      <Box value={currentTab} index={2} hidden={currentTab !== 2}>
        <EdgesTable visible={currentTab === 2} />
      </Box>
    </Box>
  );
}
